/* tslint:disable */
/* eslint-disable */
/**
 * 輸送ロット調整API
 * 重量、パレット数、容量制約に基づいてアイテムを輸送ロットに割り当てるAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CalculateTransportLot400Response,
  OptimizeTransportLot200Response,
  OptimizeTransportLotRequest,
  TransportLotRequest,
  TransportLotResponse,
} from '../models/index';
import {
    CalculateTransportLot400ResponseFromJSON,
    CalculateTransportLot400ResponseToJSON,
    OptimizeTransportLot200ResponseFromJSON,
    OptimizeTransportLot200ResponseToJSON,
    OptimizeTransportLotRequestFromJSON,
    OptimizeTransportLotRequestToJSON,
    TransportLotRequestFromJSON,
    TransportLotRequestToJSON,
    TransportLotResponseFromJSON,
    TransportLotResponseToJSON,
} from '../models/index';

export interface CalculateTransportLotRequest {
    transportLotRequest: TransportLotRequest;
}

export interface OptimizeTransportLotOperationRequest {
    optimizeTransportLotRequest: OptimizeTransportLotRequest;
}

export interface OptimizeOrderQuantityRequest {
    orderQuantityOptimizeRequest: any;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * 利用可能な輸送手段、アイテム詳細、最小積載容量要件に基づいて最適な輸送ロット割り当てを作成
     * 輸送ロットへの割り当て
     */
    async calculateTransportLotRaw(requestParameters: CalculateTransportLotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransportLotResponse>> {
        if (requestParameters.transportLotRequest === null || requestParameters.transportLotRequest === undefined) {
            throw new runtime.RequiredError('transportLotRequest','Required parameter requestParameters.transportLotRequest was null or undefined when calling calculateTransportLot.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/transport-lot`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TransportLotRequestToJSON(requestParameters.transportLotRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransportLotResponseFromJSON(jsonValue));
    }

    /**
     * 利用可能な輸送手段、アイテム詳細、最小積載容量要件に基づいて最適な輸送ロット割り当てを作成
     * 輸送ロットへの割り当て
     */
    async calculateTransportLot(requestParameters: CalculateTransportLotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransportLotResponse> {
        const response = await this.calculateTransportLotRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 輸送ロットの最適化を行い、より効率的な積載計画を生成
     * 輸送ロットの最適化
     */
    async optimizeTransportLotRaw(requestParameters: OptimizeTransportLotOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OptimizeTransportLot200Response>> {
        if (requestParameters.optimizeTransportLotRequest === null || requestParameters.optimizeTransportLotRequest === undefined) {
            throw new runtime.RequiredError('optimizeTransportLotRequest','Required parameter requestParameters.optimizeTransportLotRequest was null or undefined when calling optimizeTransportLot.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/transport-lot-optimize`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OptimizeTransportLotRequestToJSON(requestParameters.optimizeTransportLotRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OptimizeTransportLot200ResponseFromJSON(jsonValue));
    }

    /**
     * 輸送ロットの最適化を行い、より効率的な積載計画を生成
     * 輸送ロットの最適化
     */
    async optimizeTransportLot(requestParameters: OptimizeTransportLotOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OptimizeTransportLot200Response> {
        const response = await this.optimizeTransportLotRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 発注数量の最適化を行い、推奨発注数量を計算
     * 発注数量最適化
     */
    async optimizeOrderQuantityRaw(requestParameters: OptimizeOrderQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.orderQuantityOptimizeRequest === null || requestParameters.orderQuantityOptimizeRequest === undefined) {
            throw new runtime.RequiredError('orderQuantityOptimizeRequest','Required parameter requestParameters.orderQuantityOptimizeRequest was null or undefined when calling optimizeOrderQuantity.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/order-quantity-optimize`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orderQuantityOptimizeRequest as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * 発注数量の最適化を行い、推奨発注数量を計算
     * 発注数量最適化
     */
    async optimizeOrderQuantity(requestParameters: OptimizeOrderQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.optimizeOrderQuantityRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
